import { lazy, Suspense } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
import LoginMessage from './LoginMessage';

// Large decorative SVG, only needed on the login page.
const PlatformFooter = lazy(() => import('../platform-footer/platform-footer'));

const AuthGuard = ({ children }) => (
    <>
        <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
        <UnauthenticatedTemplate>
            <LoginMessage />
            <Suspense fallback={null}>
                <PlatformFooter />
            </Suspense>
        </UnauthenticatedTemplate>
    </>
);

export default AuthGuard;
